export default {
    keys: {
        id: 'id',
        productType: 'productType.id'
    },
    operators: {
        in: 'In',
        lowerThan: 'Lt',
        greaterThan: 'Gt',
    },
    inputTypes: {
        checkboxes: 'checkboxes',
    },
    queryParams: {
        page: 'page',
        text: 'text',
    },
    cookies: {
        listBlockView: 'listBlockView',
    },
    magicStrings: {
        queryCount: '{{queryCount}}',
        totalCount: '{{totalCount}}',
    },
    quiztypes: {
        radio: 'SingleAnswerQuestionItem',
        checkbox: 'MultipleAnswerQuestionItem',
        draggable: 'SliderCombinationItem',
        text: 'TextOpmerkingItem',
        score: 'OverviewItem',
    },
}